import { Context, createContext, useContext } from "react";

import { EditFormMode, RydeAdminUnit } from "@ryde/shared";

import { IEditFormDataAdmin } from "../hooks";

export interface ICrudEditAdminContext<T> {
  data: IEditFormDataAdmin<T>;
  entity: RydeAdminUnit | "unknown";
  mode?: EditFormMode;
  idCopyFrom?: number;
  idOverload?: number;
}

const getInitialContext = <T>(): ICrudEditAdminContext<T> => {
  return {
    data: {} as IEditFormDataAdmin<T>,
    entity: "unknown",
    mode: EditFormMode.CrudRoute,
  };
};

const createCrudEditAdminContext = <T>(): Context<ICrudEditAdminContext<T>> => {
  return createContext<ICrudEditAdminContext<T>>(getInitialContext<T>());
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CrudEditAdminContext = createCrudEditAdminContext<any>();

CrudEditAdminContext.displayName = "Crud Edit Admin";

export const useCrudEditAdminContext = <T>(): ICrudEditAdminContext<T> =>
  useContext(CrudEditAdminContext);

export { CrudEditAdminContext };
